export function capitalize (value) {
    return value[0].toUpperCase() + value.substring(1).toLowerCase();
}
export function uncapitalize (value) {
    return value.toLowerCase();
}